import React, {Component} from 'react';
import {Container, Row, Col, CardGroup, Card, CardBody, Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import { app } from '../../../base'

function ShowMessage(props) {
  return <div className="alert alert-info" role="alert" style={{display:props.show}}>{props.message}</div>;
}

class Login extends Component {
  constructor(props) {
    super(props)
    if (sessionStorage.authenticated=="true") {
      this.state = {
        redirect: true
      }
    }
    else {
      this.state = {
        message: '',
        redirect: false,
        show: 'none'
      }
    }
  }

  authWithEmailPassword(event) {
    event.preventDefault()
    this.setState({
      message: 'Logging in...',
      show: ''
    })

    const email = this.emailInput.value
    const password = this.passwordInput.value

    app.auth().fetchProvidersForEmail(email)
      .then((providers) => {
        if (providers.length === 0) {
          //console.log('email not found');
        }
        else {
          // sign user in
          return app.auth().signInWithEmailAndPassword(email, password)
        }
      })
      .then((user) => {
        //console.log(user);
        if (user && user.email) {
          app.database().ref('/users/' + user.uid).once('value').then((snapshot) => {
            if (snapshot.val().status == 1) {
              let user_type = parseInt((snapshot.val() && snapshot.val().user_type) || 0);
              sessionStorage.setItem("uid", user.uid);
              sessionStorage.setItem("user_type", user_type);

              this.loginForm.reset();
              this.setState({
                redirect: true
              });
            }
            else {
              this.setState({
                message: 'Your user status is inactive'
              });
              app.auth().signOut().then(function() {
                // Sign-out successful.
                //console.log('signed out');
              }, function(error) {
                // An error happened.
              });
            }
          });
        }
      })
      .catch((error) => {
        //console.log(error);
        this.setState({
          message: error.message,
          redirect: false,
          show: '',
        });
      });
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } }

    if (this.state.redirect === true) {
      return <Redirect to={from} />
    }
    
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <CardGroup>
                <Card className="p-4">
                  <form onSubmit={(event) => { this.authWithEmailPassword(event) }} ref={(form) => { this.loginForm = form }}>
                    <ShowMessage show={this.state.show} message={this.state.message} />
                    <CardBody>
                      <h1>Login</h1>
                      <p className="text-muted">Sign In to your account</p>
                      <InputGroup className="mb-3">
                        <InputGroupAddon>@</InputGroupAddon>
                        <Input name="email" type="text" placeholder="Email" innerRef={(input) => { this.emailInput = input }} />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon><i className="icon-lock"></i></InputGroupAddon>
                        <Input name="password" type="password" placeholder="Password" innerRef={(input) => { this.passwordInput = input }} />
                      </InputGroup>
                      <Row>
                        <Col xs="6">
                          <Button color="primary" className="px-4">Login</Button>
                        </Col>
                        <Col xs="6" className="text-right">
                          <Link to="/forgot-pass"><Button color="link" className="px-0">Forgot password?</Button></Link>
                        </Col>
                      </Row>
                    </CardBody>
                  </form>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js